
import { EventEmitter } from 'events';

export default class Threshold extends EventEmitter {
  constructor (name, value, min = 400, max = 2400, interval = 1) {
    super();

    this.nickName = name;
    this.value = value;
    this.min = min;
    this.max = max;
    this.interval = interval;
  }

  change (v) {
    this.value = v;
    this.emit('change', this);
  }
}



// WEBPACK FOOTER //
// ./src/assets/javascripts/ui/Threshold.js